export default __webpack_public_path__ + "static/media/admin.fcfd9611.svg";